export const ROW_NUMBER_COLUMN_KEY = "pnr-rownumber";
export const EXPANDABLE_COLUMN_KEY = "pnr-expandable-toggle";
export const SELECTABLE_COLUMN_KEY = "pnr-selectable";
export const SELECTABLE_ROW_CLASS = "pnr-table__row--selectable";
export const CLEAR_ANNOUNCEMENT_TIMEOUT = 5000;
export const COLLAPSE_COLUMNS_DEBOUNCE_TIME_MS = 50;
export const RESIZE_DEBOUNCE_TIME_MS = 35;
export const ACTION_COLUMN_PREFIX = "pnr-";
export const RESPONSIVE_MINIMUM_COLUMNS_ALLOWED = 2;